"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/PlaidConnectFlow/shared/PlaidDashedUploadButton";

import React from "react";

const I18n = I18nUtil.createScoped(Translations);

export interface PlaidDashedUploadButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  label?: string;
  className?: string;
  variant?: "empty" | "compact";
}

export const PlaidDashedUploadButton: React.FC<
  PlaidDashedUploadButtonProps
> = ({
  onClick,
  disabled = false,
  // `~...~` 为 i18n 扫描标记（review #7）：scan 会改写为 I18n.t 并生成 translate 模块
  label = I18n.t("Upload materials"),
  className = "",
  variant = "compact",
}) => {
  const isEmptyVariant = variant === "empty";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      data-openreplay-label="plaidconnectflow_upload_pick"
      className={`w-full border border-dashed border-border_inverse_transparent10 hover:border-content_brand_primary rounded-3 flex items-center justify-center cursor-pointer transition-colors bg-transparent hover:bg-background_solid_primary disabled:opacity-50 disabled:cursor-not-allowed ${
        isEmptyVariant
          ? "h-11 gap-1 px-4 py-3 rounded-2"
          : "h-12 gap-2.5 px-3 py-3"
      } ${className}`}
      data-testid="plaid-dashed-upload-btn"
      aria-label={label}
    >
      {isEmptyVariant ? (
        <img
          src="/assets/images/plaid/manual-upload/cloud-upload.svg"
          alt=""
          aria-hidden="true"
          className="h-5 w-5 shrink-0"
        />
      ) : (
        <div className="size-6 rounded-full bg-background_brand_overlay20 flex items-center justify-center shrink-0">
          <img
            src="/assets/images/plaid/manual-upload/plusback-to-top.svg"
            alt=""
            aria-hidden="true"
            className="h-5 w-5"
          />
        </div>
      )}
      <span
        className={`font-medium text-content_brand_primary ${
          isEmptyVariant ? "text-sm leading-5" : "text-xs leading-4"
        }`}
      >
        {label}
      </span>
    </button>
  );
};
